import React from "react";
import { Modal } from "react-bootstrap";

import HSGPopupContainer from "../../../HSGPopup/HSGPopupComponent";

import EpisodeList from "../Episode/EpisodeList";
import StudentCard from "./StudentCard";
import EpisodeForm from "../Episode/EpisodeForm";

class StudentProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultLimit: 5,
      defaultOffset: 0,
      defaultSortField: "modified_time",
      defaultSortBy: "desc",
      defaultSearchString: "",

      episodesList: [],
      episodesTotal: 0,
      episodesHeader: {},

      studentEpisodeHeader: {},

      toggleEpisodeModal: false,
    };
  }

  componentWillMount() {
    let { episodeHeader, studentId, organizationId } = this.props;

    let studentEpisodeHeader = Object.assign(
      this.state.studentEpisodeHeader,
      {},
      {
        inLimit: this.state.defaultLimit,
        inOffset: this.state.defaultOffset,
        inSortField: this.state.defaultSortField,
        inSortBy: this.state.defaultSortBy,
        inStudentId: studentId,
        inOrganizationId: organizationId,
        inSearchString: this.state.defaultSearchString,
      },
    );

    this.setState({
      studentEpisodeHeader,
    });

    this.props.fetchEpisodeSearch(
      this.props.buildHeader(studentEpisodeHeader, episodeHeader),
    );
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    // if (this.props.episodeHeader !== nextProps.episodeHeader){
    //     nextProps.fetchEpisodeSearch(
    //         nextProps.buildHeader(
    //             {
    //                 "inStudentId": nextProps.studentId,
    //                 "inOrganizationId": nextProps.organizationId,
    //             },
    //             nextProps.episodeHeader
    //         )
    //     )
    // }
  }

  _calculateAge() {
    // birthday is a date
    var ageDifMs =
      Date.now() - new Date(this.props.studentProfile.dob).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    return parseInt(
      (ageDate.getUTCFullYear() - 1970 + ("." + ageDate.getMonth())) * 12,
    );
  }

  _renderEpisodeTimeline = (props) => (
    <EpisodeList
      episodeList={props.episodeList}
      episodeTotal={props.episodeTotal}
      episodeHeader={this.state.studentEpisodeHeader}
      buildEpisodeHeader={(newHeader, oldHeader) =>
        props.buildHeader(newHeader, oldHeader)
      }
      fetchEpisodeSearch={(header) => props.fetchEpisodeSearch(header)}
      openStudentProfile={(studentId) => props.openStudentProfile(studentId)}
      noDataAvailable={(msg) => props.noDataAvailable(msg)}
      basicInfo={props.basicInfo}
      parentInfo={props.parentInfo}
      episodeInfo={props.episodeInfo}
      organizationId={props.organizationId}
      studentId={props.studentId}
      headingLeft={props.headingLeft}
      headingRight={props.headingRight}
      enableEpisodeIdInBody={props.enableEpisodeIdInBody}
      enableEpisodeIdLabelBody={props.enableEpisodeIdLabelBody}
      baseClass={""}
      enableSearch={false}
      enableSort={false}
    />
  );

  _renderStudentProfileCard = (props) => (
    <StudentCard
      studentProfile={props.studentProfile}
      episodeList={props.episodeList}
      closeStudentProfile={props.closeStudentProfile}
      toggleEpisodeModal={(flag) => this.toggleEpisodeModal(flag)}
    />
  );

  toggleEpisodeModal = (flag) => {
    this.setState({
      toggleEpisodeModal: flag,
    });
  };

  closeEpisodeForm = () => {
    this.toggleEpisodeModal(false);
    this.props.fetchEpisodeSearch(
      this.props.buildHeader(
        this.state.studentEpisodeHeader,
        this.props.episodeHeader,
      ),
    );
    // this.props.closeStudentProfile()
  };

  _renderEpisodeFormBody = (props) => (
    <EpisodeForm
      initializeForm={(data) => this.props.initializeForm(data)}
      toggleModal={(flag) => this.toggleEpisodeModal(flag)}
      postEpisode={(customJson, episodeType) =>
        this.props.postStudentEpisode(props.studentId, customJson, episodeType)
      }
      toggleEpisodeModal={(flag) => this.toggleEpisodeModal(flag)}
      closeEpisodeForm={this.closeEpisodeForm}
      metaData={props.metaData}
      age={this._calculateAge()}
      clearForm={() => this.props.clearForm}
    />
  );

  _renderEpisodeFormModal = (props) => (
    <HSGPopupContainer
      show={this.state.toggleEpisodeModal}
      header={"Add Episode"}
      onClose={() => this.toggleEpisodeModal(false)}
      onSubmit={(data) => this.toggleEpisodeModal(data)}
      onHide={() => this.toggleEpisodeModal(false)}
      body={this._renderEpisodeFormBody(props)}
    />
  );

  render() {
    let props = this.props;

    return (
      <div className="container" style={{ marginTop: 20 }}>
        <div className="col-md-12 col-sm-12 col-xs-12">
          {props.studentProfile
            ? this._renderStudentProfileCard(props)
            : props.noDataAvailable("Something Went Wrong!!!")}
        </div>
        <div className="col-md-12 col-sm-12 col-xs-12">
          {props.episodeList
            ? this._renderEpisodeTimeline(props)
            : props.noDataAvailable(
                "Episodes for this student is Not Available.",
              )}
        </div>

        {this.state.toggleEpisodeModal && this._renderEpisodeFormModal(props)}
      </div>
    );
  }
}

export default StudentProfile;

// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import HSGPopupContainer from '../../../HSGPopup/HSGPopupComponent';
// import EpisodeList from '../Episode/EpisodeList';
// import StudentCard from './StudentCard';
// import EpisodeForm from '../Episode/EpisodeForm';
// import SmartClinic from '../SmartClinic';
// import StudentProfile1 from '../../../StudentProfileContainer/Component/StudentProfile'

// const StudentProfile = (props) => {
//     const [defaultLimit, setDefaultLimit] = useState(5);
//     const [defaultOffset, setDefaultOffset] = useState(0);
//     const [defaultSortField, setDefaultSortField] = useState('modified_time');
//     const [defaultSortBy, setDefaultSortBy] = useState('desc');
//     const [defaultSearchString, setDefaultSearchString] = useState('');
//     const [episodesList, setEpisodesList] = useState([]);
//     const [episodesTotal, setEpisodesTotal] = useState(0);
//     const [episodesHeader, setEpisodesHeader] = useState({});
//     const [studentEpisodeHeader, setStudentEpisodeHeader] = useState({});
//     const [toggleEpisodeModal, setToggleEpisodeModal] = useState(false);

//     useEffect(() => {
//         const { episodeHeader, studentId, organizationId } = props;
//         const newStudentEpisodeHeader = {
//             inLimit: defaultLimit,
//             inOffset: defaultOffset,
//             inSortField: defaultSortField,
//             inSortBy: defaultSortBy,
//             inStudentId: studentId,
//             inOrganizationId: organizationId,
//             inSearchString: defaultSearchString
//         };
//         setStudentEpisodeHeader(newStudentEpisodeHeader);
//         props.fetchEpisodeSearch(props.buildHeader(newStudentEpisodeHeader, episodeHeader));
//     }, []);

//     const closeEpisodeForm = () => {
//         setToggleEpisodeModal(false);
//         props.fetchEpisodeSearch(props.buildHeader(studentEpisodeHeader, props.episodeHeader));
//     };

//     const calculateAge = () => {
//         const ageDifMs = Date.now() - new Date(props.studentProfile.dob).getTime();
//         const ageDate = new Date(ageDifMs);
//         return parseInt(((ageDate.getUTCFullYear() - 1970) + ('.' + ageDate.getMonth())) * 12);
//     };

//     const renderEpisodeTimeline = () => (
//         <StudentProfile1
//             episodeList={props.episodeList}
//             episodeTotal={props.episodeTotal}
//             episodeHeader={studentEpisodeHeader}
//             buildEpisodeHeader={(newHeader, oldHeader) => props.buildHeader(newHeader, oldHeader)}
//             buildHeader={props.buildHeader}
//             fetchEpisodeSearch={(header) => props.fetchEpisodeSearch(header)}
//             openStudentProfile={(studentId) => props.openStudentProfile(studentId)}
//             noDataAvailable={(msg) => props.noDataAvailable(msg)}
//             basicInfo={props.basicInfo}
//             parentInfo={props.parentInfo}
//             episodeInfo={props.episodeInfo}
//             organizationId={props.organizationId}
//             studentId={props.studentId}
//             headingLeft={props.headingLeft}
//             headingRight={props.headingRight}
//             enableEpisodeIdInBody={props.enableEpisodeIdInBody}
//             enableEpisodeIdLabelBody={props.enableEpisodeIdLabelBody}
//             baseClass={''}
//             enableSearch={false}
//             enableSort={false}
//         />
//     );

//     const renderStudentProfileCard = () => (
//         <StudentCard
//             studentProfile={props.studentProfile}
//             episodeList={props.episodeList}
//             closeStudentProfile={props.closeStudentProfile}
//             toggleEpisodeModal={(flag) => setToggleEpisodeModal(flag)}
//         />
//     );

//     const renderEpisodeFormBody = () => (
//         <EpisodeForm
//             initializeForm={(data) => props.initializeForm(data)}
//             toggleModal={(flag) => setToggleEpisodeModal(flag)}
//             postEpisode={(customJson, episodeType) => props.postStudentEpisode(props.studentId, customJson, episodeType)}
//             toggleEpisodeModal={(flag) => setToggleEpisodeModal(flag)}
//             closeEpisodeForm={closeEpisodeForm}
//             metaData={props.metaData}
//             age={calculateAge()}
//             clearForm={() => props.clearForm()}
//         />
//     );

//     const renderEpisodeFormModal = () => (
//         <HSGPopupContainer
//             show={toggleEpisodeModal}
//             onClose={() => setToggleEpisodeModal(false)}
//             onSubmit={(data) => setToggleEpisodeModal(data)}
//             onHide={() => setToggleEpisodeModal(false)}
//             body={renderEpisodeFormBody()}
//             closeEpisodeForm={closeEpisodeForm}
//             clearForm={() => props.clearForm()}
//         />
//     );

//     return (
//         <div className="container" style={{marginTop: 20}}>
//             <div className="col-md-12 col-sm-12 col-xs-12">
//                 {props.studentProfile ? renderStudentProfileCard() : props.noDataAvailable('Something Went Wrong!!!')}
//             </div>
//             <div className="col-md-12 col-sm-12 col-xs-12">
//                 {props.episodeList ? renderEpisodeTimeline() : props.noDataAvailable('Episodes for this student is Not Available.')}
//             </div>
//             {toggleEpisodeModal && renderEpisodeFormModal()}
//         </div>
//     );
// };

// export default StudentProfile;
